module.exports = __webpack_public_path__ + "img/4.fd3642a3.jpg";